import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Zustand store for sidebar state management
 * - Tracks expanded hub
 * - Tracks expanded sections within a hub
 * - Tracks active workspace
 * - Persists state to localStorage
 */
export const useSidebarState = create(
  persist(
    (set, get) => ({
      // Active workspace ID
      activeWorkspaceId: null,
      
      // Single expanded hub ID (only one hub can be expanded at a time)
      expandedHubId: null,
      
      // Expanded sections within the current hub view
      expandedSections: ['channels', 'whiteboards'],
      
      // User online status
      userStatus: 'online',
      
      // Actions
      setActiveWorkspace: (workspaceId) => set({ 
        activeWorkspaceId: workspaceId,
        expandedHubId: null  // Reset expanded hub when workspace changes
      }),
      
      setExpandedHub: (hubId) => set((state) => ({
        expandedHubId: state.expandedHubId === hubId ? null : hubId
      })),
      
      toggleSection: (sectionId) => set((state) => ({
        expandedSections: state.expandedSections.includes(sectionId)
          ? state.expandedSections.filter(s => s !== sectionId)
          : [...state.expandedSections, sectionId]
      })),
      
      setUserStatus: (status) => set({ userStatus: status }),
      
      // Reset sidebar state
      resetSidebar: () => set({
        expandedHubId: null,
        expandedSections: ['channels', 'whiteboards'],
      }),
    }),
    {
      name: 'boardchat-sidebar-state',
      partialize: (state) => ({
        activeWorkspaceId: state.activeWorkspaceId,
        expandedHubId: state.expandedHubId,
        expandedSections: state.expandedSections,
        userStatus: state.userStatus,
      }),
    }
  )
);

export default useSidebarState;
